<div class="table-card insights-filters-card">
  <h4 class="card-title">التصفية</h4>

  <div class="filters-row">
    <div class="filter-select">
      <ng-select
        #selectExperts
        class="filter-ng-select"
        appendTo="body"
        [(ngModel)]="filters.expertId"
        (ngModelChange)="onChange()"
        [searchable]="true"
        [clearable]="false"
        placeholder="كل الخبراء"
        (scrollToEnd)="onScrollExpertsPagination()"
        (search)="searchExpertsText()"
        (clear)="resetExpertsSearch()"
        (open)="resetExpertsSearch()"
      >
        <ng-option [value]="null">كل الخبراء</ng-option>
        @for (option of expertOptions; track option.value) {
          <ng-option [value]="option.value">{{ option.label }}</ng-option>
        }
      </ng-select>
    </div>

    <div class="filter-select">
      <ng-select
        class="filter-ng-select"
        appendTo="body"
        [(ngModel)]="filters.specializationId"
        (ngModelChange)="onChange()"
        [searchable]="true"
        [clearable]="false"
        placeholder="كل التخصصات"
      >
        <ng-option [value]="null">كل التخصصات</ng-option>
        @for (option of specialtyOptions; track option.value) {
          <ng-option [value]="option.value">{{ option.label }}</ng-option>
        }
      </ng-select>
    </div>

    <div class="filter-select">
      <ng-select
        class="filter-ng-select"
        appendTo="body"
        [(ngModel)]="filters.cohortId"
        (ngModelChange)="onChange()"
        [searchable]="true"
        [clearable]="false"
        placeholder="كل المجموعات"
      >
        <ng-option [value]="null">كل المجموعات</ng-option>
        @for (option of cohortOptions; track option.value) {
          <ng-option [value]="option.value">{{ option.label }}</ng-option>
        }
      </ng-select>
    </div>

    <div class="filter-select">
      <select [(ngModel)]="filters.status" (ngModelChange)="onChange()">
        @for (option of statusOptions; track option.label) {
          <option [ngValue]="option.value">{{ option.label }}</option>
        }
      </select>
    </div>

    <div class="filter-select has-leading-icon">
      <select [(ngModel)]="filters.dateRange" (ngModelChange)="onDateRangeChange()">
        @for (option of dateRangeOptions; track option.value) {
          <option [ngValue]="option.value">{{ option.label }}</option>
        }
      </select>
      <img class="leading-icon" src="assets/images/svg/clock.svg" alt="" width="20" height="20" />
    </div>

    @if (filters.dateRange === 'custom') {
      <div class="filter-date-range">
        <input type="date" [(ngModel)]="filters.dateFrom" (ngModelChange)="onChange()" />
        <span class="separator">-</span>
        <input type="date" [(ngModel)]="filters.dateTo" (ngModelChange)="onChange()" />
      </div>
    }
  </div>
</div>
